import ServerConfig from './config'
export default ServerConfig
